module.exports = __webpack_public_path__ + "static/media/IMG_8039.4158bb14.jpg";